const CalloutIcon = () => (
  <svg
    width="39"
    height="47"
    viewBox="0 0 39 47"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.051 37.8172C32.6254 35.8018 39 28.2183 39 
          19.1711C39 8.5832 30.2696 0 19.5 0C8.7304 0 0 8.5832 
          0 19.1711C0 28.6954 7.0647 36.5976 16.3233 38.089L20.1291 
          46.9999L24.051 37.8172Z"
      fill="#F5F5F5"
    />
  </svg>
);
export default CalloutIcon;
